import React from "react";
import SargamStudio from "../components/SargamStudio";

const SargamNotation = () => {
    return (
        <main className="min-h-screen bg-slate-900 py-6">
            <SargamStudio />
        </main>
    );
};

export default SargamNotation;
